import type { RowType } from '../../types/RowType';
import { HEADER_TEXT_HEIGHT, UNASSIGNED, AVAILABLE } from '../constants';

export const UnassignedHeader: RowType = {
  id: 'UnassignedShiftsHeader',
  rowType: 'HeaderTextRow',
  rowData: {
    type: UNASSIGNED,
    text: 'Unassigned shifts',
    size: HEADER_TEXT_HEIGHT,
  },
};

export const AvailableHeader: RowType = {
  id: 'AvailableShiftsHeader',
  rowType: 'HeaderTextRow',
  rowData: {
    type: AVAILABLE,
    text: 'Available shifts',
    size: HEADER_TEXT_HEIGHT,
  },
};

export const ScheduledShiftsHeader: RowType = {
  id: 'ScheduledShiftsHeader',
  rowType: 'HeaderTextRow',
  rowData: {
    text: 'Scheduled shifts',
    size: HEADER_TEXT_HEIGHT,
  },
};
